import React from "react";
import Head from "next/head";
import Link from "next/link";
import funnel from "../styles/Funnel.module.css";
import Box from "@mui/material/Box";
import Footer from "../component/footer";
import { Typography } from "@mui/material";

export default function Disclaimer() {
  return (
    <>
      <Head>
        <title>Disclaimer</title>
        <link
          rel="canonical"
          href="https://abodefinder.com.au/disclaimer/"
        ></link>
        <meta name="description" content="" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>
      </Head>
      <div className={funnel.allFunnel}>
        <div className={funnel.funnelChance}>
          <div className={funnel.funnelBody} style={{ marginTop: "40px" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
              <div className={funnel.boxQn}>
                <div className={funnel.privacy}>
                  <Typography variant="h4" sx={{ mb: 5 }}>
                    Disclaimer
                  </Typography>
                  <p>
                    At AbodeFinder, we want to make it clear that the investment
                    recommendations provided by our platform are generated by
                    artificial intelligence and should not be considered
                    financial or property advice. We believe that every
                    individual's financial and investment goals are unique, and
                    as such, we cannot provide personalized advice on which
                    property to buy or invest in.
                  </p>
                  <br></br>
                  <p>
                    Our platform is designed to analyze market trends and key
                    metrics to suggest potential investment opportunities based
                    on your selected preferences. However, it is important to
                    note that these suggestions are not intended to replace
                    professional advice, nor should they be relied upon as a
                    substitute for professional investment advice or a thorough
                    analysis of the individual property and its associated
                    risks.
                  </p>
                  <br></br>
                  <p>
                    AbodeFinder is committed to providing our clients with
                    accurate, data-driven information to help them make informed
                    investment decisions. However, we cannot provide any
                    guarantees on the investment performance or future returns
                    of any property listed on our platform.
                  </p>
                  <br></br>
                  <p>
                    We encourage our clients to seek professional advice from a
                    licensed financial advisor or a licensed property
                    professional before making any investment decisions.
                    Ultimately, the decision to invest in a property is a
                    personal one, and we want to make sure that our clients have
                    all the information they need to make informed decisions
                    based on their individual circumstances.
                  </p>
                  <br></br>
                  <p>
                    The Data provided in this publication is of a general nature
                    and should not be construed as specific advice or relied
                    upon in lieu of appropriate professional advice. While
                    MasterAbode PTY LTD. uses commercially reasonable efforts to
                    ensure the data is current, MasterAbode does not warrant the
                    accuracy, currency or completeness of the data and to the
                    full extent permitted by law excludes all loss or damage
                    howsoever arising (including through negligence) in
                    connection with the data.
                  </p>
                  <br></br>
                  <p>
                    This is intended for informational purposes only and may not
                    be reproduced or re-disseminated in any form and may not be
                    used as a basis for or a component of any financial
                    decisions.
                  </p>
                  <br></br>
                  <p>
                    MasterAbode PTY LTD. does not warrant the accuracy, currency
                    or completeness of the prediction and to the full permitted
                    by law, MasterAbode excludes all liability for any loss or
                    damage howsoever arising in connection with all data in
                    MasterAbode PTY LTD.
                  </p>
                </div>
              </div>
            </Box>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
